import React from "react";
import {Box} from "@mui/material";

const DEFAULT_COVER_IMAGE = 'https://hscnews.usc.edu/wp-content/uploads/2020/09/shutterstock_1415786840.jpg'

interface ArticleCardProps {
  onClick: () => void;
  coverImage: string;
  title: string;
  category: string;
  division: string;
}

export const PostCard = ({
  onClick,
  coverImage,
  title,
  category,
  division
}: ArticleCardProps) => (
  <Box
    className={`
      p-3 cursor-pointer bg-white flex flex-1 items-stretch space-x-4 rounded-xl
      transition-all duration-150 active:scale-95 hover:scale-105 hover:shadow-lg active:shadow-none
    `}
    onClick={onClick}
  >
    <img
      src={coverImage ? coverImage : DEFAULT_COVER_IMAGE}
      alt=""
      className="w-[100px] h-[100px] object-cover rounded-md"
    />
    <div className="flex flex-col justify-between flex-1">
      <div className="flex flex-col items-start">
        <div className="py-1 rounded-2xl text-xs text-gray-400">
          {category}
        </div>
        <div className="text-lg font-bold mb-1 text-left">
          {title}
        </div>
      </div>
      <div className="text-gray-400 text-sm self-end">
        {division}
      </div>
    </div>
  </Box>
)

